<div *ngIf="integration?.id">
    <app-integration-preview [integration]="integration" *ngIf="preview"></app-integration-preview>
</div>
